import React from "react";
//Material imports
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/HighlightOff";

var SlideCloseIcon = function SlideCloseIcon(_ref) {
  var classes = _ref.classes,
      isMobileDevice = _ref.isMobileDevice,
      onClose = _ref.onClose,
      slide = _ref.slide;

  if (!isMobileDevice) {
    return null;
  }

  var closeIconColor = slide.closeIconColor,
      closeIconBackgroundColor = slide.closeIconBackgroundColor,
      contrastColour = slide.contrastColour;
  var iconColor = closeIconColor || contrastColour;
  var backgroundColor = closeIconBackgroundColor || "transparent";
  return /*#__PURE__*/React.createElement(IconButton, {
    style: {
      backgroundColor: backgroundColor
    },
    className: classes.icon,
    component: "div",
    onClick: onClose,
    disableTouchRipple: true
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    style: {
      color: iconColor
    }
  }));
};

var styles = {
  icon: {
    position: "absolute",
    right: 0,
    top: 0,
    padding: 8,
    margin: 8,
    borderRadius: "50%"
  }
};
export default withStyles(styles)(SlideCloseIcon);